__turbopack_context__.v({
  "headerActionsPopup": "VTjSpW_headerActionsPopup",
  "headerBackButton": "VTjSpW_headerBackButton",
  "headerButton": "VTjSpW_headerButton",
  "headerCloseButton": "VTjSpW_headerCloseButton",
  "headerContainer": "VTjSpW_headerContainer",
  "headerLeft": "VTjSpW_headerLeft",
  "headerMoreActionsButton": "VTjSpW_headerMoreActionsButton",
  "headerTitle": "VTjSpW_headerTitle",
  "subHeader": "VTjSpW_subHeader",
});
